/*
*
* Bloc "Conseiller proche de chez vous"
*
*/

var loadBtns = require('./btn-mail-tel-call-func');

const { magasinsUI } = require('../pages/magasinsPromiximites');

// console.log('magasinsUI', magasinsUI)

// $(document).ready(function(){


//   $('body').on('click','.js-btn-magasinproximite', function(){


//     if ("geolocation" in navigator) {

//       navigator.geolocation.getCurrentPosition(function(position) {

//         $('#serviceMagasinProximite .js-nogeocode').addClass('d-none');
//         console.log( position );

//         if( !position ){  //refus geocode
//           $('#serviceMagasinProximite .js-nogeocode').removeClass('d-none');
//         }else{
//           refreshMagasinProximite(position.coords);
//           refreshDropdownMagasin(position.coords, false);
//         }

//       },function(error){
//         $('#serviceMagasinProximite .js-nogeocode').removeClass('d-none');
//       });


//     } else {
//       //pas de geocode possible
//       $('#serviceMagasinProximite .js-nogeocode').removeClass('d-none');
//     }

//   } );

//   $('body').on('change','.js-select-magasins', function(){
//     var strLatLng = $(this).val();
//     var arrLatLng = strLatLng.split(',');

//     var coords = new Object();
//     coords.latitude = arrLatLng[0];
//     coords.longitude = arrLatLng[1];

//     refreshMagasinProximite(coords);
//     refreshDropdownMagasin(coords, false);
//   });

//   // $('body').on('click','#js-modif-magasin', function(){
//   //   $('.js-select-mag-hidden').show();
//   // });


//   initUIProximite();

// });

let magasinsUIComponent = new magasinsUI({
  options: {
    file: '',
    ajax: true,
    geoloc: false,
    url:  route('ajax.pays.full').template,
    token: window.Laravel.csrfToken,
    elements: {
      mapName: 'map-conseiller'
    }
  },
  hooks : {
    ready : function(instance) {
      // id="wrapper_ui"
      loadBtns();
      // console.log(' i m ready bitch ')
    },
  }
})

// console.log('magasinsUIComponent', magasinsUIComponent)

$(document).ready(function(){
  magasinsUIComponent.init();
})





// /**
//  * Refresh le bloc
//  */
// function refreshMagasinProximite( coords ){


//   $.ajaxSetup({
//     headers: {
//       'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//     }
//   });
//   $.ajax({
//     url: "/ajax/magasin/proximite",
//     data:{
//       lat: coords.latitude,
//       lng: coords.longitude
//     },
//     dataType: 'json',
//     method: 'POST'
//   }).done(function(response) {

//     if( response.success == "1" ){

//         $('#serviceMagasinProximite').replaceWith( response.html );
//         initUIProximite();
//         //init map
//       $('#to').val($('#js-modif-magasin').data('email'));

//     }else{
//       //do something
//     }

//   });

// }


// function initUIProximite() {

//   //@todo Gérer affichage num tel et mail

//   loadMapMagasin();
//   loadBtns();
//   initDropzone();
// }


  // function loadMapMagasin() {

  //   if( $('#map-conseiller[data-markerlat]').length > 0 ){
  //     var markerHtml = $('#map-conseiller');
  //     var mymap = L.map('map-conseiller').setView([markerHtml.data('markerlat'), markerHtml.data('markerlng')], 13);

  //     //skin de la map
  //     L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
  //       attribution: '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  //       minZoom: 1,
  //       maxZoom: 19
  //     }).addTo(mymap);


  //     var trocIcon = L.icon({
  //       iconUrl: '/images/locator-troc.svg',
  //       iconSize: [48, 48]
  //     });

  //     L.marker([markerHtml.data('markerlat'), markerHtml.data('markerlng')], {
  //         icon: trocIcon
  //       })
  //       //.bindPopup( markerHtml.html() )//ajout du marker magasin (désactivé, mais marche)
  //       .addTo(mymap);
  //     }
  // }
